"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FieldPickerDirection;
(function (FieldPickerDirection) {
    FieldPickerDirection["OUTGOING"] = "outgoing";
    FieldPickerDirection["INCOMING"] = "incoming";
})(FieldPickerDirection = exports.FieldPickerDirection || (exports.FieldPickerDirection = {}));
(function (FieldPickerDirection) {
    function reverse(fieldPickerDirection) {
        if (fieldPickerDirection === FieldPickerDirection.OUTGOING) {
            return FieldPickerDirection.INCOMING;
        }
        return FieldPickerDirection.OUTGOING;
    }
    FieldPickerDirection.reverse = reverse;
})(FieldPickerDirection = exports.FieldPickerDirection || (exports.FieldPickerDirection = {}));
//# sourceMappingURL=field-picker-direction.js.map